<template>
  <b-card
    title="مدیریت قیمت ها"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="col-md-2 pl-1 d-flex align-items-end">
              <b-button
                class="mb-1"
                variant="primary"
                :to="{ name: 'adddietdurationprice'}"
              >
                جدید
              </b-button>
            </div>
          </b-row>
          <b-row class="mt-1">
            <b-col md="2">
              <b-form-group
                  label="عنوان"
                  label-for="Title"
              >
                <b-form-input
                    v-model="filterOptions.Title"
                    type="text"
                    class="d-inline-block"
                    @keyup.enter="update(1)"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group
                  label="نوع رژیم"
                  label-for="DietType"
              >
                <v-select
                    v-model="filterOptions.DietType"
                    :options="enums('DietType')"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group
                  label="دوره"
                  label-for="DietDuration"
              >
                <z-diet-duration v-model="filterOptions.DietDurationId" :clearable="true" />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group
                  label="گروه ورزشی"
                  label-for="ActivityGroup"
              >
                <z-activity-group v-model="filterOptions.ActivityGroupId" :clearable="true" :multiple="false" />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group
                  label="وضعیت"
                  label-for="IsActive"
              >
                <v-select
                    v-model="filterOptions.IsActive"
                    :options="enums('IsActive')"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                />
              </b-form-group>
            </b-col>
            <b-col md="2" class="d-flex align-items-center">
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
            </b-col>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              :to="{ name: 'updatedietdurationprice', params: { id: data.value }}"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(DietType)="data">
            {{ enums('DietType', 'value', data.value, 'text') }}
          </template>

          <template #cell(DietDuration)="data">
            {{ data.value.Title }}
          </template>

          <template #cell(Price)="data">
            {{ data.value | price }}
          </template>

          <template #cell(Discount)="data">
            {{ data.value | price }}
          </template>

          <template #cell(PayPrice)="data">
            {{ data.item.Price - data.item.Discount | price }}
          </template>

          <template #cell(IsActive)="data">
            <b-badge
              :variant="data.value ? 'success' : 'warning'"
            >
              {{ data.value ? 'فعال' : 'غیرفعال' }}
            </b-badge>
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
              <b-link :to="{ name: 'updatedietdurationprice', params: { id: data.item.Id }}">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>
              <feather-icon

                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>
  </b-card>
</template>

<script>

import ZDietDuration from "@/tools/dietduration.vue";
import ZActivityGroup from '@/tools/activitygroup.vue'

export default {
  name: 'DietDurationPrice',
  components: {ZDietDuration, ZActivityGroup},
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
        IsActive: null,
        DietType: null,
        DietDurationId: null,
        ActivityGroupId: null,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'DietType',
          label: 'نوع',
        },
        {
          key: 'UniversalPackageId',
          label: 'عنوان در گوگل پلی',
        },
        {
          key: 'ActivityGroupTitle',
          label: 'گروه ورزشی',
        },
        {
          key: 'DietDuration',
          label: 'دوره',
        },
        {
          key: 'Price',
          label: 'مبلغ',
        },
        {
          key: 'Discount',
          label: 'تخفیف',
        },
        {
          key: 'PayPrice',
          label: 'مبلغ نهایی',
        },
        {
          key: 'IsActive',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.dietdurationprice.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    remove(id) {
      this.removeRow(this.$api.dietdurationprice.remove, 'Id', id)
    },
  },
}
</script>
